module.exports = __webpack_public_path__ + "fonts/SFProText-Regular.06b45761.woff";